/* ==========================================================================
   Header Animation
   ========================================================================== */

// ...

import gsap from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";

function scrollReveal() {
  gsap.registerPlugin(SplitText, ScrollTrigger);
  gsap.config({ nullTargetWarn: false });
  const innerSplit = new SplitText(".hd-reveal", {
      type: "lines",
    }),
    outerSplit = new SplitText(".hd-reveal", {
      type: "lines",
    });

  ScrollTrigger.batch(innerSplit.lines, {
    start: "top 90%",
    once: true,
    onEnter: (batch) =>
      gsap.to(batch, {
        delay: 0.1,
        yPercent: 0,
        duration: 1.5,
        stagger: 0.1,
        ease: "power4",
      }),
  });
  gsap.set(innerSplit.lines, { yPercent: 105 });
}

window.addEventListener("load", function () {
  scrollReveal();
});
